module.exports = __webpack_public_path__ + "img/icon-arrow-left.83b4c63b.svg";